import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@sopranodesign/pulse-icons';

import BlockContainer from '../../BlockContainer';
import TextPreview from '../../TextPreview';

const VariableBlock = ({ icon, colour, ...props }) => {
  return (
    <BlockContainer colour={colour} {...props} aria-label="Variable block">
      <Icon outline type={icon} /> <TextPreview>{props.base.name}</TextPreview>
    </BlockContainer>
  );
};

VariableBlock.propTypes = {
  icon: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  base: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  ).isRequired
};

export default VariableBlock;
